import React from 'react';
import { motion } from 'framer-motion';

export default function Checkbox({
  checked = false,
  onCheckedChange,
  size = 'large', // small | medium | large
  disabled = false,
  className = '',
  ...props
}) {
  const sizeClasses = {
    small: 16,
    medium: 20,
    large: 24,
  };

  const baseClasses = 'shrink-0 items-center justify-center border rounded focus:outline-none';

  const checkedClasses = checked ? 'bg-primary-500 border-primary-500' : 'bg-white border-gray-400';
  const disabledClasses = disabled ? 'opacity-50 cursor-not-allowed pointer-events-none' : 'cursor-pointer';

  return (
    <motion.button
  type="button"
  onClick={() => !disabled && onCheckedChange(!checked)}
  className={`${baseClasses} ${disabledClasses} ${checkedClasses}`}
  style={{
    width: sizeClasses[size],
    height: sizeClasses[size],
    minWidth: sizeClasses[size],
    minHeight: sizeClasses[size],
    flexShrink: 0,
    boxSizing: 'border-box',
  }}  
  animate={{
    scale: checked ? [1, 1.3, 1] : 1, // animacja w keyframes
    backgroundColor: checked ? '#ad160e' : '#ffffff',
    borderColor: checked ? '#ad160e' : '#9ca3af',
  }}
  transition={{
    type: 'tween', // zamiast spring
    duration: 0.2,
  }}
>
  {checked && (
    <motion.svg
      className="text-white"
      fill="none"
      stroke="currentColor"
      strokeWidth="3"
      viewBox="0 0 24 24"
      initial={{ scale: 0 }}
      animate={{ scale: 1 }}
      transition={{ type: 'spring', stiffness: 500, damping: 20 }}
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
    </motion.svg>
  )}
</motion.button>
  );
}
